import { axiosInstance } from 'api/apiConfig'
import { setNextPageParam, setNextPageQuery } from 'api/apiUtil'
import { useInfiniteQuery, useMutation, useQuery } from 'react-query'
import { objectToQueryString } from 'utils/object-to-query-string'

// 상품 연결 요청
const getHeadNotice = async (target, params) => {
  const { data } = await axiosInstance.get(
    `api/cmmty/connect/v1.0${target ? '/' + target : ''}${objectToQueryString(params)}`,
  )
  return data
}
// 상품 연결 요청
const postHeadNotice = async (target, params) => {
  const { data } = await axiosInstance.post(`api/cmmty/connect/v1.0${target ? '/' + target : ''}`, params)
  return data
}
// 상품 연결 요청
const pupHeadNotice = async (target, params) => {
  const { data } = await axiosInstance.put(`api/cmmty/connect/v1.0${target ? '/' + target : ''}`, params)
  return data
}

// 상품 연결 요청 목록
export const useGoodsCnetReqMngLst = (params, isInit) => {
  return useInfiniteQuery(
    ['selectGoodsCnetReqMngLst', params],
    ({ pageParam = params }) => getHeadNotice('goodsCnetReqMngLst', pageParam),
    {
      enabled: isInit,
      getNextPageParam: setNextPageParam(params),
    },
  )
}
// 상품 연결 요청 상세
export const useGoodsCnetReqMngDtl = (seq, isInit) => {
  const params = { schNtcAtclId: seq }
  return useQuery(
    ['selectGoodsCnetReqMngLst'],
    ({ pageParam = params }) => postHeadNotice('goodsCnetReqMngDtl', pageParam),
    {
      enabled: isInit,
    },
  )
}
// 상품 연결 요청 수정
export const useGoodsCnetReqMngEdit = ({ successHandler, errorHandler }) => {
  return useMutation((params) => postHeadNotice(`updateGoodsCnetReq`, params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}
// 상품 연결 요청 생성
export const useGoodsCnetReqMngReg = ({ successHandler, errorHandler }) => {
  return useMutation((params) => postHeadNotice(`insertGoodsCnetReqReg`, params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}

export const useSrchGoods = (params, isInit) => {
  return useQuery(
    ['selectSrchGoods', params],
    ({ pageParam = params }) => getHeadNotice('srchgoods', pageParam),
    //() => getHeadNotice('srchgoods', params),
    {
      enabled: isInit,
      //getNextPageParam: setNextPageParam(params),
    },
  )
}